import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	originalEstimateTooltip: {
		id: 'backlog.card-list.card.card-contents.original-estimate-field.original-estimate-tooltip',
		defaultMessage: 'Original estimate',
		description: 'Tooltip around original estimate field',
	},
	originalEstimateAriaLabel: {
		id: 'backlog.card-list.card.card-contents.original-estimate-field.original-estimate-aria-label',
		defaultMessage: 'Original estimate',
		description: 'Accessibility label for original estimate field',
	},
	originalEstimateAriaLabelNullValue: {
		id: 'backlog.card-list.card.card-contents.original-estimate-field.original-estimate-aria-label-null-value',
		defaultMessage: 'No estimate set',
		description: 'Accessibility label for original estimate field',
	},
	invalidTimeFormatMessage: {
		id: 'backlog.card-list.card.card-contents.original-estimate-field.invalid-time-format-message',
		defaultMessage: 'Your estimate must be in the format {format}.',
		description: 'error message when user enter invalid in original estimate input',
	},
});
